<p-table stripedRows #dtPayroll
    [value]="items"
    tableStyleClass="table p-datatable-full"
    dataKey="id"
    editMode="row"
    [style]="{ 'min-width': '70em', width: '100%' }"
    (onRowSelect)="onRowSelect($event)"
    scrollHeight="65vh"
    [scrollable]="true"
    [virtualRowHeight]="30"
    tableStyleClass="p-datatable-full"
    styleClass="p-datatable-center"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="6" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header>
        <tr>
            <!-- Edit -->
            <th class="edit-cell"></th>
            <!-- Status-->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Payroll Code-->
            <th>
                Payroll Code
                <p-sortIcon
                    pSortableColumn="PayrollDisplay"
                    field="PayrollDisplay"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter field="Paycode" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                        defaultLabel="Filter"
                        maxSelectedLabels="1"
                        appendTo="body"
                        [options]="payrollCodesSelectItems"
                        [filter]="true"
                        styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                    ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Column Header -->
            <th>
                Column Header
                <p-sortIcon
                    pSortableColumn="Colheader"
                    field="Colheader"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter field="Colheader" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                        defaultLabel="Filter"
                        maxSelectedLabels="1"
                        appendTo="body"
                        [options]="payrollCodesColumnHeaderSelectItems"
                        [filter]="true"
                        styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                    ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Code Description-->
            <th>
                Code Description
                <p-sortIcon
                    pSortableColumn="AccountName"
                    field="AccountName"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter field="Paycodedesc" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                        defaultLabel="Filter"
                        maxSelectedLabels="1"
                        appendTo="body"
                        [options]="payrollCodesDescSelectItems"
                        [filter]="true"
                        styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                    ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Is Premium-->
            <th>
                Is Premium
                <p-sortIcon
                    pSortableColumn="IsPremium"
                    field="IsPremium"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Is LWOP-->
            <th>
                Is LWOP
                <p-sortIcon
                    pSortableColumn="IsLWOP"
                    field="IsLWOP"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Delete-->
            <th class="delete-cell"></th>
        </tr>
    </ng-template>
    <ng-template
        #body
        let-item
        let-edit="editing"
        let-ri="rowIndex"
        let-rowData
    >
        <tr
            [pSelectableRow]="item"
            [pEditableRow]="item"
            data-id="row-{{ item.id }}"
            [ngClass]="{
                'ui-editing-row': edit && editing?.id === rowData?.id
            }"
        >
            <!-- Edit -->
            <td class="edit-cell">
                <!-- for a new row -->
                <button
                    *ngIf="item?.id === 'add' && !edit"
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-plus"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditInit(item)"
                ></button>
                <button
                    *ngIf="
                        !edit &&
                        (!editing?.id || editing?.id === item?.id) &&
                        item.id !== 'add'
                    "
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text"
                    (click)="onRowEditInit(item)"
                    title="Edit"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditSave(item)"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="onRowEditCancel(item)"
                ></button>
            </td>
            <!-- Status-->
            <td class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Payroll Code-->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly && !externalIntegration" pTemplate="input">
                        <input pInputText [(ngModel)]="item.Paycode" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly || externalIntegration" pTemplate="input">
                        {{ item?.Paycode }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item?.Paycode }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Column Header-->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly && !externalIntegration" pTemplate="input">
                        <input pInputText [(ngModel)]="item.Colheader" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly && externalIntegration" pTemplate="input">
                        {{ item?.Colheader }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item?.Colheader }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Code Description-->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.Paycodedesc" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item?.Paycodedesc }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item?.Paycodedesc }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Is Premium -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <p-checkbox
                        binary="true"
                        [(ngModel)]="item.IsPremium"
                        [ngModelOptions]="{
                            standalone: true
                        }"
                    ></p-checkbox>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i
                        [ngClass]="{
                            pi: true,
                            'pi-check': item?.IsPremium,
                            green: item?.IsPremium
                        }"
                    ></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i
                        [ngClass]="{
                            pi: true,
                            'pi-check': item?.IsPremium,
                            green: item?.IsPremium
                        }"
                    ></i>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Is LWOP -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <p-checkbox
                        binary="true"
                        [(ngModel)]="item.IsLWOP"
                        [ngModelOptions]="{
                            standalone: true
                        }"
                    ></p-checkbox>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i
                        [ngClass]="{
                            pi: true,
                            'pi-check': item?.IsLWOP,
                            green: item?.IsLWOP
                        }"
                    ></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i
                        [ngClass]="{
                            pi: true,
                            'pi-check': item?.IsLWOP,
                            green: item?.IsLWOP
                        }"
                    ></i>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Delete -->
            <td class="delete-cell">
                <button
                    *ngIf="
                        !edit &&
                        (!editing?.id || editing?.id === item?.id) &&
                        item.id !== 'add'
                    "
                    pButton
                    style="font-size: 0.65rem"
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="onRowDelete(item)"
                ></button>
            </td>
        </tr>
    </ng-template>
</p-table>
